import React from 'react';
import { LoaderHolderProps } from '../type';
import { uid } from '../api';

function Svg({
  rtl,
  speed,
  interval,
  style,
  width,
  height,
  viewBoxWidth,
  viewBoxHeight,
  baseUrl,
  gradientRatio,
  animate,
  ariaLabel,
  children,
  className,
  uniquekey,
  primaryColor,
  primaryOpacity,
  secondaryColor,
  secondaryOpacity,
  preserveAspectRatio,
  ...props
}: LoaderHolderProps) {
  const idClip = uniquekey ? `${uniquekey}-idClip` : uid();
  const idGradient = uniquekey ? `${uniquekey}-idGradient` : uid();
  const rtlStyle = rtl ? { transform: 'scaleX(-1)' } : {};
  const keyTimes = `0; ${interval}; 1`;
  const dur = `${speed}s`;
  gradientRatio = gradientRatio ? gradientRatio : 0;

  return (
    <svg
      role="img"
      style={{ ...style, ...rtlStyle }}
      className={className}
      aria-label={ariaLabel ? ariaLabel : undefined}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      preserveAspectRatio={preserveAspectRatio}
      width={width}
      {...(height ? { height: height } : {})}
    >
      {ariaLabel ? <title>{ariaLabel}</title> : null}
      <rect
        x="0"
        y="0"
        width={viewBoxWidth}
        height={viewBoxHeight}
        clipPath={`url(${baseUrl}#${idClip})`}
        style={{ fill: `url(${baseUrl}#${idGradient})` }}
      />

      <defs>
        <clipPath id={idClip}>{children}</clipPath>
        <linearGradient id={idGradient}>
          <stop
            offset="0%"
            stopColor={primaryColor}
            stopOpacity={primaryOpacity}
          >
            {animate && (
              <animate
                attributeName="offset"
                values={`${-gradientRatio}; ${-gradientRatio}; 1`}
                keyTimes={keyTimes}
                dur={dur}
                repeatCount="indefinite"
              />
            )}
          </stop>
          <stop
            offset="50%"
            stopColor={secondaryColor}
            stopOpacity={secondaryOpacity}
          >
            {animate && (
              <animate
                attributeName="offset"
                values={`${-gradientRatio / 2}; ${-gradientRatio / 2}; ${
                  1 + gradientRatio / 2
                }`}
                keyTimes={keyTimes}
                dur={dur}
                repeatCount="indefinite"
              />
            )}
          </stop>
          <stop
            offset="100%"
            stopColor={primaryColor}
            stopOpacity={primaryOpacity}
          >
            {animate && (
              <animate
                attributeName="offset"
                values={`0; 0; ${1 + gradientRatio}`}
                keyTimes={keyTimes}
                dur={dur}
                repeatCount="indefinite"
              />
            )}
          </stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Svg;
